import {
  OnMultipleQueriesSnapshot,
  OnMultipleQueriesSnapshotInput,
  OnQuerySnapshot,
  Unsubscribe,
} from './types';

export function makeOnMultipleQueriesSnapshot(
  onQuerySnapshot: OnQuerySnapshot,
): OnMultipleQueriesSnapshot {
  return function onMultipleQueriesSnapshot<T>(
    input: OnMultipleQueriesSnapshotInput<T>,
  ): Unsubscribe {
    const { collection: coll, queries, onNext, onError, sortPredicate } = input;
    let mergedData: { sourceQueryIndex: number; item: T }[] = [];

    const unsubscribes: Unsubscribe[] = [];

    const unsubscribe = () => {
      unsubscribes.forEach((u) => u());
    };

    const onNextWrapper = (data: T[], sourceQueryIndex: number) => {
      const wrappedData = data.map((item) => ({
        sourceQueryIndex,
        item,
      }));

      const newUnsortedData = mergedData.filter(
        (itemWrapper) => itemWrapper.sourceQueryIndex !== sourceQueryIndex, // remove all items from the same source query
      );

      const sortedData = [...newUnsortedData, ...wrappedData].sort((a, b) => {
        return sortPredicate(a.item) - sortPredicate(b.item);
      });

      mergedData = [...sortedData];
      onNext(sortedData.map((itemWrapper) => itemWrapper.item));
    };

    queries.forEach(({ where, order }, sourceQueryIndex) => {
      unsubscribes.push(
        onQuerySnapshot<T>({
          collection: coll,
          where,
          order,
          onNext: (items) => onNextWrapper(items, sourceQueryIndex),
          onError,
        }),
      );
    });

    return unsubscribe;
  };
}
